import { createActionGroup, props } from '@ngrx/store';
import { ProductTariffUuid } from '@products/models/booking.model';

export const BookingProductTariffActions = createActionGroup({
  source: 'Booking Product Tariff',
  events: {
    'Set booking product tariff uuid': props<{ productTariffUuid: ProductTariffUuid }>(),
    'Remove booking product tariff uuid': props<{ productTariffUuid: ProductTariffUuid }>()
  }
});
